export default "__VITE_ASSET__CS6BuW4Q__"